// extracted by mini-css-extract-plugin
export var pageTitle = "pageTitle-module--page-Title--bg24z";
export var pageTitleBg = "pageTitle-module--pageTitleBg--+ybv+";
export var pageTitleContainer = "pageTitle-module--pageTitleContainer--v1+Sh";